// originalCode.js
import axios from "axios";
import jwtDecode from "jwt-decode";
import { getToken, setToken } from "./tokenStore";
import { errorToast } from "../react-toastfiy/toast";
import { getLocationHeaders } from "../helpers/functions/locationService";

const excludedURLs = ["/refreshToken", "/login"];

let tokenAboutToExpire = false;
let fetchingRefreshToken = false;
let requestQueue = [];
// const ERP_BASE_URL = "https://erpbackendtest.meratractor.com";
// const ERP_BASE_URL = "http://localhost:8000";

// const AUCTION_BASE_URL = "https://api.meratractor.com";
const AUCTION_BASE_URL = "https://test.meratractor.com";
// const AUCTION_BASE_URL = "http://localhost:8001";

function createAxiosInstance(baseURL) {
  const axiosInstance = axios.create({
    baseURL,
  });

  axiosInstance.interceptors.request.use(async (config) => {
    let token = getToken();

    if (token) {
      const decoded_access_token_exp_time = jwtDecode(token).exp;
      const current_time_second = Math.round(new Date() / 1000);
      if (decoded_access_token_exp_time <= current_time_second) {
        token = undefined;
      }
    }
    const refreshToken = localStorage.getItem("refreshToken");
    if (refreshToken && !token && !fetchingRefreshToken) {
      fetchingRefreshToken = true;
      tokenAboutToExpire = true;
      try {
        const response = await axios.post(
          `/refreshToken`,
          {},
          {
            headers: {
              Authorization: refreshToken,
            },
          },
        );

        if (response.data.status === 200) {
          const newAccessToken = response.data.token;
          setToken(newAccessToken);
          tokenAboutToExpire = false;
          fetchingRefreshToken = false;
          requestQueue.forEach(({ resolve, config }) => {
            resolve({
              ...config,
              headers: {
                ...config?.headers,
                Authorization: newAccessToken,
                ...getLocationHeaders(),
              },
            });
          });
          requestQueue = [];

          return {
            ...config,
            headers: {
              ...config?.headers,
              Authorization: newAccessToken,
              ...getLocationHeaders(),
            },
          };
        } else if (response.data.status === 401) {
          errorToast("Session expired. Please log in again.");
          localStorage.clear();
          window.location.replace("/sign-in");
          tokenAboutToExpire = false;
          fetchingRefreshToken = false;
          requestQueue = []; // Clear
        } else {
          errorToast(response.data.msg);
        }
      } catch (error) {
        errorToast("Session expired. Please log in again.");
        console.error("Error refreshing token:", error);
      }
    }

    if (token || !tokenAboutToExpire || excludedURLs.includes(config.url)) {
      return {
        ...config,
        headers: {
          ...config?.headers,
          Authorization: token,
          ...getLocationHeaders(),
        },
      };
    } else {
      return new Promise((resolve) => {
        requestQueue.push({ resolve, config });
      });
    }
  });

  axiosInstance.interceptors.response.use((response) => {
    if (response?.data?.status === 419) {
      localStorage.clear();
      errorToast(response?.data?.msg);
      window.tokenAboutToExpire = false;
      window.fetchingRefreshToken = false;
      window.requestQueue = [];
      setTimeout(() => {
        window.location.replace("/sign-in");
      }, 500);
    }
    return response;
  });

  return axiosInstance;
}

export const cookieAxios = createAxiosInstance(AUCTION_BASE_URL);
